import { render, staticRenderFns } from "./StudentsListFilters.vue?vue&type=template&id=2c1fe9a6"
import script from "./StudentsListFilters.vue?vue&type=script&lang=js"
export * from "./StudentsListFilters.vue?vue&type=script&lang=js"
import style0 from "./StudentsListFilters.vue?vue&type=style&index=0&id=2c1fe9a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports